var $ = require('jquery');

$(function(){

  $('.js-ft-Service__itemHead').on('click', function() {

    if($(this).next().css('display') ==　'none') {
      // $('.js-is-show').slideUp();
      $(this).parent().addClass('is-margin');

      // $('.js-ft-Service__itemHead').children("p").show();
      $(this).children("p").fadeOut(0);
      $(this).next().slideToggle();

    } else {
      $(this).parent().removeClass('is-margin');
      $(this).next().slideToggle(300, function(){
        $(this).prev().children("p").fadeIn(300);
      });
    }
  });
});